module.exports = __webpack_public_path__ + "assets/img/BC.5623c432.svg";